import React, { useState, useEffect } from "react";
import Logo from "../../images/logo1.png";
import layout from "../../css/landing.module.css";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import styles from "../../css/viewmembers.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faHouse,
  faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

function Paytithefaith() {

  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  // PAGINATION
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useEffect(() => {

    axios
      .get("https://appserver.cemkharistemple.com/faithallmembers")
      .then((response) => {

        setUsers(response.data);
        setLoading(false);

      })
      .catch((error) => {

        console.error("Error fetching data:", error);
        setLoading(false);

      });

  }, []);

  const handleSearch = (event) => {

    setSearchTerm(event.target.value);
    setCurrentPage(1);

  };

  const filteredUsers = users.filter((user) =>
    user.church_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.first_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.last_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;

  const currentRows = filteredUsers.slice(
    indexOfFirstRow,
    indexOfLastRow
  );

  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);

  const handleLogout = () => {

    localStorage.clear();
    window.location.href = "/";

  };

  return (

    <div className={layout.container}>

      {/* HEADER */}

      <Topbar title="Pay Tithe" subtitle="Select a member to record tithe" />

      {/* SIDEBAR */}

      <Sidebar variant="faith" />

      {/* MAIN */}

      <main className={layout.main}>

        <div className={styles.wrapper}>

          <div className={styles.card}>

            <div className={styles.cardHeader}>
              <h3>Search Member</h3>
              <span>(Search by ID or Name)</span>
            </div>

            <input
              type="text"
              placeholder="Search by Name or Church Number"
              value={searchTerm}
              onChange={handleSearch}
              className={styles.searchbar}
            />

            {loading ? (

              <div className={styles.loading}>
                Loading members...
              </div>

            ) : (

              <>
                <div className={styles.tableContainer}>

                  <table className={styles.table}>

                    <thead>
                      <tr>
                        <th>Church ID</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                      </tr>
                    </thead>

                    <tbody>

                      {currentRows.length > 0 ? (

                        currentRows.map((user) => (

                          <tr key={user.id}>

                            <td>

                              <Link
                                to={`/paytithefaith/${user.church_id}`}
                              >
                                {user.church_id}
                              </Link>

                            </td>

                            <td>{user.first_name}</td>

                            <td>{user.last_name}</td>

                          </tr>

                        ))

                      ) : (

                        <tr>
                          <td colSpan="3" className={styles.noData}>
                            No members found
                          </td>
                        </tr>

                      )}

                    </tbody>

                  </table>

                </div>

                {/* PAGINATION */}

                <div className={styles.pagination}>

                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    Prev
                  </button>

                  {[...Array(totalPages)].map((_, index) => (

                    <button
                      key={index}
                      className={
                        currentPage === index + 1
                          ? styles.activePage
                          : ""
                      }
                      onClick={() => setCurrentPage(index + 1)}
                    >
                      {index + 1}
                    </button>

                  ))}

                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    Next
                  </button>

                </div>

              </>
            )}

          </div>

        </div>

      </main>

    </div>
  );
}

export default Paytithefaith;